import React from 'react';
import { Form, Table, Switch, message, Tabs } from 'antd';
import { getOtherSettingListNo, getOtherSettingEdit } from '@/request/api'
import { requestErrorLog } from '@/common/util'
const { TabPane } = Tabs;
class OtherSetting extends React.Component {
	state = {
		PageNo: 1,
		PageSize: 10,
		columns: [
			{
				title: "必填项名称",
				dataIndex: "REQUIRED_NAME",
				key: "REQUIRED_NAME",
				width: 320,
			},
			{
				title: "是否必填",
				dataIndex: "ISREQUIRED",
				key: "ISREQUIRED",
				align: 'center',
				width: 160,
				render: (text, record) => {
					return (
						<Switch defaultChecked={text} onChange={this.onChangeRequired.bind(this, record)} />
					)
				}
			},
		],
		dataList: [],
		RowCount: 0,
		showKey: 1,
	}
	componentDidMount() {
		this.getOtherSettingList();
	}
	getOtherSettingList = () => {//获取数据
		let SET_TYPE = this.state.showKey;
		getOtherSettingListNo(SET_TYPE).then((res) => {
			if (res && res.Status === 1) {
				this.setState({
					dataList: res.Result.length > 0 ? res.Result.filter(item => item.REQUIRED_NAME.trim() !== '病历号' && item.REQUIRED_NAME.trim() !== '检查号' && item.REQUIRED_NAME.trim() !== '申请号') : []
				})
			}else{
				requestErrorLog('', '系统设置-其他设置-获取数据报错', 0, true)
			}

		})
	}
	changePageFn = (PageNo) => {//切换页面
		this.setState({
			PageNo
		}, () => {
			this.getOtherSettingList();
		})
	}
	onChangeRequired = (record, checked) => {//修改是否必选
		let RequestModel = {
			ISREQUIRED: checked,//必填true，非必填false
			REQUIRED_UID: record.REQUIRED_UID//唯一uid
		}
		getOtherSettingEdit(RequestModel).then((res) => {
			if (res && res.Status === 1) {
				if (res.Result === -1) {
					message.error('编辑失败!')
				}
				else {
					message.success('编辑成功!')
				}
			}else{
				requestErrorLog('', '系统设置-其他设置-修改是否必填项目报错', 0, true)
			}
		})
	}
	handleTabKey = (e) => {
		this.setState({
			showKey: e
		}, () => {
			this.getOtherSettingList()
		})
	}
	render() {
		const { columns, dataList, showKey } = this.state
		return (
			<Form className="formWrap eleWrap applyTd">
				<Tabs activeKey={showKey + ''} type="card" onChange={this.handleTabKey}>
					<TabPane key="1" tab={<p className="badgeText">患者信息</p>}>
						<Table
							columns={columns}
							dataSource={dataList}
							rowKey={(record) => record.REQUIRED_UID}
							pagination={false}
							className='othersettinglist' />
					</TabPane>
					<TabPane key="2" tab={<p className="badgeText">患者转诊</p>}>
						<Table columns={columns}
							dataSource={dataList}
							rowKey={(record) => record.REQUIRED_UID}
							pagination={false}
							className='othersettinglist' />
					</TabPane>

				</Tabs>
			</Form>
		)
	}
}
export default OtherSetting